import React from "react";
import { cacheUtils } from "../../../../../../../../../..";
import useDebugInformation from "../../../../../../../../../../hooks/useDebugInformation";
import { useAppSelector } from "@store/hooks";
import { CacheTypes } from "@utils/cache/interfaces";
import ComboDropDown from "../../../../../../../../../Shared/ComboDropDown";
import { tradeGetOptionLabel, tradeIsOptionEqualToValue, handleTradeChange } from "./helpers";

const name = "TradeDropDown"

type Props = {
    parent: string
}

const TradeDropDown: React.FC<Props> = ({ parent }) => {
    const problemComboTrade = useAppSelector(({ ui }) => ui.ProblemComboTrade)

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent, problemComboTrade })
    return (
        <ComboDropDown
            sm={6}
            name="Trade"
            options={cacheUtils.getCache<CacheTypes.TradeTypes>("TradeTypes")}
            getOptionLabel={tradeGetOptionLabel}
            isOptionEqualToValue={tradeIsOptionEqualToValue}
            onChange={handleTradeChange}
            value={problemComboTrade}
        />
    )
}

export default React.memo(TradeDropDown)